/* =========================================================================
   et-blog-arrows.js - Ela Teila
   "THE STORIES BEHIND ELA TEILA" - slinkimo juostele po straipsniais.

   Kraunama is snippets/et-scroll-keep.liquid.
   GRAZINIMAS: istrinti ta <script> eilute snippete.

   ---------------------------------------------------------------------
   KODEL REIKEJO

   Straipsniu sarasas yra horizontalus slankiklis (matuota: scrollWidth
   1040px, matoma 375px), bet kito straipsnio issikisa tik ~23px, tad
   nesimato, kad galima slinkti.

   Pirma buvo padarytos rodykles, bet Rita pasirinko tokia pat juostele,
   kokia Home puslapyje po atsiliepimais:
     <span class="gallery__progress-bar progress-bar">  1px auksčio,
     seka rgb(212,217,222), tamsi dalis rodo, kurioje vietoje esi.

   Temos blog-posts sekcija tokios juosteles neturi, todel ji cia
   sukuriama ir atnaujinama slenkant.
   ========================================================================= */
(function () {
  function build() {
    var sec = document.querySelector('[id$="__blog_posts_77atVc"]');
    if (!sec) return;

    var old = sec.querySelector('.et-blog-arrows');
    if (old) old.remove();
    if (sec.querySelector('.et-blog-progress')) return;

    var scroller = null;
    var all = sec.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (all[i].scrollWidth > all[i].clientWidth + 4) { scroller = all[i]; break; }
    }
    if (!scroller) return;

    var wrap = document.createElement('div');
    wrap.className = 'et-blog-progress';
    var fill = document.createElement('span');
    fill.className = 'et-blog-progress__fill';
    wrap.appendChild(fill);
    scroller.parentNode.insertBefore(wrap, scroller.nextSibling);

    function update() {
      var max = scroller.scrollWidth - scroller.clientWidth;
      var ratio = scroller.clientWidth / scroller.scrollWidth;
      var pos = max > 0 ? scroller.scrollLeft / max : 0;
      fill.style.width = (ratio * 100) + '%';
      fill.style.transform = 'translateX(' + (pos * (100 / ratio - 100)) + '%)';
    }

    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
  window.addEventListener('load', build);
})();
